import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { teamsApi } from '../../../services';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Modal for creating new teams
 */
const CreateTeamModal = ({ onClose, onSuccess, users, departments }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    lead_id: '',
    department_id: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API}/teams/`, {
        ...formData,
        lead_id: formData.lead_id || null,
        department_id: formData.department_id || null
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success('Team opprettet!');
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Failed to create team:', error);
      toast.error('Kunne ikke opprette team');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
        <div className="p-6 border-b border-slate-200">
          <h2 className="text-2xl font-bold text-slate-900">Opprett team</h2>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700 block mb-1">Navn *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              required
              className="w-full px-4 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-slate-500"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-slate-700 block mb-1">Beskrivelse</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              className="w-full px-4 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-slate-500"
              rows={3}
            />
          </div>

          <div>
            <label className="text-sm font-medium text-slate-700 block mb-1">Team lead (valgfri)</label>
            <select
              value={formData.lead_id}
              onChange={(e) => setFormData({...formData, lead_id: e.target.value})}
              className="w-full px-4 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-slate-500"
            >
              <option value="">Ingen lead</option>
              {users.filter(u => u.role === 'LAWYER' || u.role === 'TENANT_ADMIN').map(user => (
                <option key={user.id} value={user.id}>{user.name}</option>
              ))}
            </select>
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
            >
              Avbryt
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 px-4 py-2 bg-slate-900 text-white rounded-lg hover:bg-slate-800 disabled:bg-slate-300"
            >
              {loading ? 'Oppretter...' : 'Opprett'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateTeamModal;
